import { FC, PropsWithChildren } from 'react';
import { Text } from '@bridebook/aura';

interface IProps extends PropsWithChildren {}

export const RsvpTitle: FC<IProps> = ({ children }) => (
  <Text variant="typo-base-semibold">{children}</Text>
);
